


























































































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import { usePersonaStore } from "@/employee/store/persona";

@Component({
  components: {
    Button,
    RadioButton
  }
})
export default class Persona extends mixins(ErrorsMixin) {
  @Prop() routeToDashboard;

  personaStore = usePersonaStore();

  firstPick: string = null;
  secondPick = "";

  isLoaded = false;

  mounted () {
    this.personaStore.getPersonaType().catch(this.handleError);
    this.updateComponentState();
  }

  @Watch("personaStore.personaAndIsLoaded")
  updateComponentState () {
    if (this.personaStore.personaAndIsLoaded.isLoaded) {
      this.isLoaded = true;
      if (this.personaStore.personaAndIsLoaded.name === "spend") {
        this.firstPick = "spend";
        this.secondPick = "";
      } else if (
          this.personaStore.personaAndIsLoaded.name === "pay" ||
          this.personaStore.personaAndIsLoaded.name === "save" ||
          this.personaStore.personaAndIsLoaded.name === "invest"
      ) {
        this.firstPick = "";
        this.secondPick = this.personaStore.personaAndIsLoaded.name;
      } else {
        this.firstPick = null;
        this.secondPick = "";
      }
    } else {
      this.isLoaded = false;
    }
  }

  get personaType () {
    if (this.firstPick === "spend") {
      return this.firstPick;
    }
    return this.secondPick;
  }

  get isNextButtonDisabled () {
    return this.isSubmitting || this.personaType === "" || this.personaType === null;
  }

  onSubmit () {
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    this.personaStore.setPersonaType(this.personaType)
        .then(() => {
          this.isSubmitting = false;
        })
        .then(() => this.$emit("complete"))
        .catch(this.handleError);
  }
}
